module.exports = __webpack_public_path__ + "img/wav2.8f535290.gif";